// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as NetworkUtils from "../../../../../../../library/NetworkUtils.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as TicketingOrderRepoConfig from "./TicketingOrderRepoConfig.bs.js";
import * as PartnerGoodwillDiscountPayload from "../../entity/PartnerGoodwillDiscountPayload.bs.js";

var dummyOrderCancelledWithoutPartnerUsecase = {
    "order_details": {
        "booking_info": {
            "customer": {
                "customer_id": 9999900,
                "contact": {
                    "number": "9999999999",
                    "name": "Goutam"
                }
            },
            "pickup_location": {
                "place": {
                    "full_address": "4th floor, 15C, Anil Maitra Road",
                    "doorstep_address": null,
                    "locality_address": "4th floor, 15C, Anil Maitra Road",
                    "location": {
                        "lat": 22.524347,
                        "long": 88.36768739999901
                    }
                },
                "contact": {
                    "name": "Goutam",
                    "number": "9999999999"
                }
            },
            "drop_location": {
                "place": {
                    "full_address": "145, East Road, Rani Rashmoni Bagan, Santoshpur, Kolkata, West Bengal 700075, India",
                    "doorstep_address": null,
                    "locality_address": "145, East Road, Rani Rashmoni Bagan, Santoshpur, Kolkata, West Bengal 700075, India",
                    "location": {
                        "lat": 22.4930137,
                        "long": 88.3858806
                    }
                },
                "contact": {
                    "name": "TEST Deb",
                    "number": "9999999999"
                }
            },
            "vehicle": {
                "vehicle_id": 97,
                "vehicle_type": "2 Wheeler",
                "capacity": "20 kg",
                "size": "40cm x 40cm x 40 cm"
            },
            "has_waypoints": false,
            "waypoints": [],
            "additional_waypoints_eligible": false,
            "additional_waypoints_allowed": false,
            "geo_region_id": 9,
            "geo_region_name": "Kolkata",
            "distance": 5.87,
            "order_source": "ios",
            "payment_mode": "cash",
            "goods_type": "General",
            "goods_type_id": 13,
            "from_state": "West Bengal",
            "to_state": "West Bengal",
            "order_type": "spot",
            "delivery_instructions": {
                "instructions_list": []
            },
            "created_at": 1704290177000,
            "delivery_note": null
        },
        "order_info": {
            "order_id": 99999000,
            "order_crn": "CRN9999999999",
            "status": "cancelled",
            "order_tracking_url": "porter.in/rd/999990",
            "pickup_time": 1704290777000,
            "order_updated_at": 1704373206000
        },
        "vas_services": {
            "is_helper_order": false,
            "is_helper_plus_labour_order": false
        },
        "partner_info": {
            "driver_msisdn": "9999999999000",
            "name": "Md Firdous",
            "vehicle_number": "UP-00-00-0000",
            "vehicle_type": "2 Wheeler",
            "mobile": "9999999999",
            "partner_secondary_mobile": "9999999999",
            "has_nep": true,
            "fuel_type": "petrol"
        },
        "miscellaneous_info": {
            "is_outstation_order": false,
            "is_rental_order": false,
            "is_otp_order": false,
            "is_business_order": false
        },
        "status_info": {
            "cancelled_order_info": {
                "cancellation_reason": "Started and ended without doing",
                "trip_cancelled_time": 1704353406000,
                "cancellation_source": "customer",
                "is_penalty_applied": true
            },
            "live_order_info": {
                "trip_started_time": 1704307299999,
                "trip_started_location": {
                    "full_address": "29A/G37, Ballygunge Park, Ballygunge, Kolkata, West Bengal 700019, India",
                    "doorstep_address": null,
                    "locality_address": "29A/G37, Ballygunge Park, Ballygunge, Kolkata, West Bengal 700019, India",
                    "location": {
                        "lat": 22.5344613,
                        "long": 88.3711244
                    }
                },
                "trip_start_entry_timestamp": 1704290281000,
                "trip_start_exit_timestamp": null
            },
            "completed_order_info": {
              "trip_completed_time": 1704353406000,
              "customer_rating": "Not yet rated",
              "order_invoice_url": null
            },
            "ended_order_info": {
                "trip_ended_time": 1704353406000,
                "dry_run_distance": 0.0,
                "dry_run_duration": 1.0,
                "trip_ended_location": {
                    "full_address": "195, 2nd Cross Rd, 7th Block, Koramangala, Bengaluru, Karnataka 560030, India",
                    "doorstep_address": null,
                    "locality_address": "195, 2nd Cross Rd, 7th Block, Koramangala, Bengaluru, Karnataka 560030, India",
                    "location": {
                        "lat": 12.9368001,
                        "long": 77.6134916
                    }
                },
                "trip_end_entry_timestamp": null,
                "breach_info": {
                    "breach_type": "Lesser than Fixed Pricing",
                    "pickup_vicinity_passed": "na",
                    "drop_vicinity_passed": "na",
                    "waypoint_vicinity_passed": "na",
                    "waiting_time_passed": "na",
                    "fixed_fallback_fare_is_higher": false
                },
                "is_return_trip": false,
                "end_trip_fare_strategy": "New Fixed Pricing",
                "previous_due": 0.0
            },
            "order_editability": {
              "is_editable": false
            },
            "accepted_order_info": {
                "trip_accepted_time": 1704290281000,
                "trip_accepted_location": {
                    "lat": 22.5341377,
                    "long": 88.3703189
                },
                "driver_location_accuracy": 78.92
            },
            "unallocated_order_info": {
                "create_trip_fare_strategy": null
            }
        }
}
};

var instaMojoDummyResponse = {
        "instamojo_payment_records": [
          {
            "amount": 0,
            "created_at": "string",
            "status": "string",
            "admin_email": "string"
          }
        ]
      };

var orderLogsDummyResponse = {
        offset: "",
        "order_logs": [
          {
            "ts_millis": 0,
            "description": "The order has been accepted by Manoj Kumar, 9082301169716 at 2020-01-15 11:21:26 +0530",
            "admin": "TEST TEST",
          },
          {
            "ts_millis": 0,
            "description": "The order has been accepted by Manoj Kumar, 9082301169716 at 2020-01-15 11:21:26 +0530",
            "admin": "TEST TEST",
          },
          {
            "ts_millis": 0,
            "description": "The order has been accepted by Manoj Kumar, 9082301169716 at 2020-01-15 11:21:26 +0530",
            "admin": "TEST TEST",
          },
          {
            "ts_millis": 0,
            "description": "The order has been accepted by Manoj Kumar, 9082301169716 at 2020-01-15 11:21:26 +0530",
            "admin": "TEST TEST",
          },
          {
            "ts_millis": 0,
            "description": "The order has been accepted by Manoj Kumar, 9082301169716 at 2020-01-15 11:21:26 +0530",
            "admin": "TEST TEST",
          },
          {
            "ts_millis": 0,
            "description": "The order has been accepted by Manoj Kumar, 9082301169716 at 2020-01-15 11:21:26 +0530",
            "admin": "TEST TEST",
          }
        ]
      };

var orderFareDummyResponse = {
    "order_fares": {
        "fare_details": {
            "estimated": {
                "amount": 96.53,
                "breakup_details": {
                    "partner_trip_fare": 97,
                    "porter_bearing_total_discount": 0,
                    "trip_fare": 97,
                    "pre_trip_fare_round_off": 0.0,
                    "base_fare": 45,
                    "travel_fare": 97,
                    "distance_charge": 25.83,
                    "travel_duration_charge": 15.7,
                    "waiting_charge": 0.0,
                    "flat_surge_amount": 10,
                    "waiting_time": 25.0,
                    "travel_distance": 5.87,
                    "travel_duration": 31.40775,
                    "pickup_extra_charge": 0.0,
                    "drop_extra_charge": 0.0,
                    "waypoints": 0,
                    "toll": 0,
                    "road_tax": 0,
                    "convenience_charge": 0,
                    "environmental_tax": 0,
                    "toll_breakup_details": [],
                    "referral_discount": 0,
                    "coupon_discount": 0,
                    "subscription_discount": 0,
                    "rewards_discount": 0,
                    "incidental_charges": {},
                    "credit_charge": 0,
                    "helper_charge": 0,
                    "helper_plus_labour_charge": 0,
                    "waypoint_charge": 0.0,
                    "tax_on_commission": 0.0,
                    "cgst_on_commission": 0.0,
                    "sgst_on_commission": 0.0,
                    "igst_on_commission": 0.0,
                    "loading_time": 12.5,
                    "unloading_time": 12.5,
                    "pod_charge": 0,
                    "fare_type": "estimated"
                },
                "toll_breakup_details": [],
                "order_fare_error": "No Error",
                "previous_due": 0.0,
                "vehicle_fare_version": {
                    "id": 4164,
                    "free_waiting_mins": 25,
                    "travel_rate_per_min": [
                        {
                            "lower_km": 0.0,
                            "upper_km": 2.0,
                            "price_per_km": 0.0,
                            "price_per_min": 0.5
                        },
                        {
                            "lower_km": 2.0,
                            "upper_km": 5.0,
                            "price_per_km": 6.0,
                            "price_per_min": 0.5
                        },
                        {
                            "lower_km": 5.0,
                            "upper_km": 1999990.0,
                            "price_per_km": 9.0,
                            "price_per_min": 0.5
                        }
                    ],
                    "capacity": "20 kg",
                    "size": "40cm x 40cm x 40 cm"
                },
                "is_manually_adjusted_fare": false
            }
        },
        "payment_mode": "cash"
    }
};

var crmTicketsDummyResponse = [{
        "case_id":"00002478",
        "created_at":1512137704,
        "raised_by":"Customer",
        "issues":[],
        "issue_comment":null,
        "actions_taken":[],
        "action_comment":null,
        "resolution_comments":{
            "total_comments":0,
            "latest_comment":null
        },
        "status":"Open"
      },{
        "case_id":"00002479",
        "created_at":1512137705,
        "raised_by":"Customer",
        "issues":[],
        "issue_comment":null,
        "actions_taken":[],
        "action_comment":null,
        "resolution_comments":{
          "total_comments":0,
          "latest_comment":null
        },
        "status":"Open"
      },{
        "case_id":"00002482",
        "created_at":1512137706,
        "raised_by":"Customer",
        "issues":["Online Payment Request/Status", "Odio tempor ornare arcu enim"],
        "issue_comment": "Educated/Convinced, Escalate To",
        "actions_taken":["Ac ut non facilisi facilisi. Posuere", "Odio tempor ornare arcu enim"],
        "action_comment": "Part, said that that the waiting is not calculated, as checked in system he has waited, so con called the cust, and informed him regarding this, but the cust, is argueing and then told that he will check in his system and then will call, then after, both disconnected, the call.",
        "resolution_comments":{
          "total_comments": 12,
          "latest_comment":"Spoke with partner and he said still i not get payment and i call to customer but he is drop the my call and i inform to partner i changed cf 00 and you will get the amount in your wallet and you can check and order is trusted and i send the link to customer and i send the SMS to him hence i inform to partner any concern to customer case will reopen he agree hence closing this case_04705670",
        },
        "status":"Open"
      },{
        "case_id":"00002447",
        "created_at":1510653431,
        "raised_by":"City supply",
        "issues":[],"issue_comment":null,
        "actions_taken":[],
        "action_comment":null,
        "resolution_comments":{
          "total_comments":0,
          "latest_comment":null
        },
        "status":"Open"
      }];

var dummy_post_call_re = {};

var orderCommentsDummyResponse = {comments: [
          {
            "timestamp": 1559131153,
            "admin_name": "TEST_TEST",
            "comment": "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet."
          },
          {
            "timestamp": 1559131153,
            "admin_name": "TEST_TEST",
            "comment": "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet."
          },
          {
            "timestamp": 1559131153,
            "admin_name": "TEST_TEST",
            "comment": "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet."
          }
        ]};

var partnerEarningsDummyResponse = {
        "earning_details": {
          "driver_id": "6666890123378",
          "order_id": "CRN999990000",
          "earnings": [
            {
              "amount": 963,
              "type": "TRIP_FARE",
              "default_title": "Trip Fare"
            },
            {
              "amount": 150,
              "type": "HELPER_CHARGE",
              "default_title": "Helper Charge"
            },
            {
              "amount": -50,
              "type": "COMMISSION",
              "default_title": "Porter Fee"
            }
          ],
          "settlements": [
            {
              "amount": 993,
              "settlement_ts": "2021-11-10T15:27:34.000+05:30",
              "default_title": "Cash",
              "is_adjustment": false
            },
            {
              "amount": 70,
              "settlement_ts": "2021-11-10T15:27:34.000+05:30",
              "default_title": "Wallet",
              "is_adjustment": false,
              "wallet_txn_id": "TXN_9999999999"
            }
          ],
          "fare_inclusions": [
            {
              "fare_type": "ROAD_TAX",
              "amount": 30.0,
              "default_title": "Road Tax"
            }
          ]
        }
      };

var orderFareV2DummyResponse = {
    "order_fares": {
        "fare_details": {
            "estimated": {
                "amount": 96.53,
                "breakup_details": {
                    "partner_trip_fare": 97,
                    "porter_bearing_total_discount": 0,
                    "trip_fare": 97,
                    "pre_trip_fare_round_off": 0.0,
                    "base_fare": 45,
                    "travel_fare": 97,
                    "distance_charge": 25.83,
                    "travel_duration_charge": 15.7,
                    "waiting_charge": 0.0,
                    "flat_surge_amount": 10,
                    "waiting_time": 25.0,
                    "travel_distance": 5.87,
                    "travel_duration": 31.40775,
                    "pickup_extra_charge": 0.0,
                    "drop_extra_charge": 0.0,
                    "waypoints": 0,
                    "toll": 0,
                    "road_tax": 0,
                    "convenience_charge": 0,
                    "environmental_tax": 0,
                    "toll_breakup_details": [],
                    "referral_discount": 0,
                    "coupon_discount": 0,
                    "subscription_discount": 0,
                    "rewards_discount": 0,
                    "incidental_charges": {},
                    "credit_charge": 0,
                    "helper_charge": 0,
                    "helper_plus_labour_charge": 0,
                    "waypoint_charge": 0.0,
                    "tax_on_commission": 0.0,
                    "cgst_on_commission": 0.0,
                    "sgst_on_commission": 0.0,
                    "igst_on_commission": 0.0,
                    "loading_time": 12.5,
                    "unloading_time": 12.5,
                    "pod_charge": 0,
                    "fare_type": "estimated"
                },
                "toll_breakup_details": [],
                "order_fare_error": "No Error",
                "previous_due": 0.0,
                "vehicle_fare_version": {
                    "id": 4164,
                    "free_waiting_mins": 25,
                    "travel_rate_per_min": [
                        {
                            "lower_km": 0.0,
                            "upper_km": 2.0,
                            "price_per_km": 0.0,
                            "price_per_min": 0.5
                        },
                        {
                            "lower_km": 2.0,
                            "upper_km": 5.0,
                            "price_per_km": 6.0,
                            "price_per_min": 0.5
                        },
                        {
                            "lower_km": 5.0,
                            "upper_km": 1999990.0,
                            "price_per_km": 9.0,
                            "price_per_min": 0.5
                        }
                    ],
                    "capacity": "20 kg",
                    "size": "40cm x 40cm x 40 cm"
                },
                "is_manually_adjusted_fare": false
            }
        },
        "payment_mode": "cash"
    }
};

var partnerGoodwillDummyResponse = {
          status: 200,
          amount: 50.0,
        };

var dummyAutoCreateTicketResponse = {
          "message": "ticket successfully created",
          "case_number": "98492000",
      };

var dummyOrderScheduleStatusResponse = {
      "schedule_order_id": 123
    };

function fetchInstaMojoDetails(param, param$1) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: instaMojoDummyResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.InstaMojoResponseConverter.execute, result);
                            });
                }), "fetchInstaMojoDetails");
}

function fetchOrderLogs(param, param$1, param$2) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: orderLogsDummyResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.OrderLogsJsonResponseConverter.execute, result);
                            });
                }), "fetchOrderLogs");
}

function fetchTicketsForOrder(_orderId, param) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: crmTicketsDummyResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.TicketsResponseConverter.execute, result);
                            });
                }), "fetchTicketsForOrder");
}

function fetchOrder(param, param$1) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyOrderCancelledWithoutPartnerUsecase
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.OrderResponseConverter.execute, result);
                            });
                }), "fetchOrder");
}

function fetchOrderSchedule(param, param$1) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyOrderScheduleStatusResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.OrderScheduleConverter.execute, result);
                            });
                }), "fetchOrderScheduleStatus");
}

function fetchOrderComments(param, param$1) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: orderCommentsDummyResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.OrderCommentsResponseConverter.execute, result);
                            });
                }), "fetchOrderComments");
}

function createOrderComments(params, _country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummy_post_call_re
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.CreateCommentResponseConverter.execute, result);
                            });
                }), "createOrderComments");
}

function fetchOrderTickets(param, param$1) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: crmTicketsDummyResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.OrderTicketsResponseConverter.execute, result);
                            });
                }), "fetchOrderTickets");
}

function fetchOrderFare(param, param$1) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: orderFareDummyResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.OrderFareResponseConverter.execute, result);
                            });
                }), "fetchOrderFare");
}

function fetchPartnerEarnings(param, param$1) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: partnerEarningsDummyResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.PartnerEarningsResponseConverter.execute, result);
                            });
                }), "fetchPartnerEarnings");
}

function fetchOrderFareBreakup(param, param$1) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: orderFareV2DummyResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.OrderFareV2ResponseConverter.execute, result);
                            });
                }), "fetchOrderFareBreakup");
}

function createPartnerGoodwillDiscount(payload, _country) {
  JSON.stringify(PartnerGoodwillDiscountPayload.t_encode(payload));
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: partnerGoodwillDummyResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.PartnerGoodwillDIscountConverter.execute, result);
                            });
                }), "createPartnerGoodwillDiscount");
}

function createTicket(param, param$1) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyAutoCreateTicketResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TicketingOrderRepoConfig.AutoCreateTicketJsonResponseConverter.execute, result);
                            });
                }), "createTicket");
}

var TicketingOrderRepo = {
  fetchInstaMojoDetails: fetchInstaMojoDetails,
  fetchOrderLogs: fetchOrderLogs,
  fetchTicketsForOrder: fetchTicketsForOrder,
  fetchOrder: fetchOrder,
  fetchOrderSchedule: fetchOrderSchedule,
  fetchOrderComments: fetchOrderComments,
  createOrderComments: createOrderComments,
  fetchOrderTickets: fetchOrderTickets,
  fetchOrderFare: fetchOrderFare,
  fetchPartnerEarnings: fetchPartnerEarnings,
  fetchOrderFareBreakup: fetchOrderFareBreakup,
  createPartnerGoodwillDiscount: createPartnerGoodwillDiscount,
  createTicket: createTicket
};

export {
  TicketingOrderRepo ,
  
}
/* NetworkUtils Not a pure module */
